<template>
  <HeaderBase>
    <div
      class="flex items-center shrink header-title w-1/5 cursor-pointer"
      @click="$router.push({
        name: 'objects.details',
        params: {
          id,
        },
      })">
      <span class="arrow arrow-l arrow-primary"></span>
      <b>Редактирование объекта</b>
    </div>
    <div class="shrink flex-container flex-dir-row align-center">
    </div>
  </HeaderBase>
</template>

<script>
import _ from 'lodash';
import HeaderBase from './HeaderBase.vue';

export default {
  components: {
    HeaderBase,
  },
  computed: {
    id() {
      return _.get(this.$route, 'params.id');
    },
  },
};
</script>
